/**
 * This is base URL for api call
 */

export let BASE_URL;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  BASE_URL = 'http://localhost:5000/api';
} else {
  BASE_URL = 'https://fabiuser.meancloud.in/api';
}

/**
 * Basic URLs
 */

//authentication
export const AUTH_URL = `${BASE_URL}/auth`;
export const PREREGISTER_OTP = `${AUTH_URL}/preauth-otp`;
export const PREREGISTER_OTP_VERIFY = `${AUTH_URL}/preauth-otp-verify`;
export const REGISTRATION_URL = `${AUTH_URL}/register`;
export const LOGIN_URL = `${AUTH_URL}/login`;
export const OTP_LOGIN_URL = `${AUTH_URL}/otp-login`;
export const GOOGLE_LOGIN_URL = `${AUTH_URL}/login-google`;
export const FACEBOOK_LOGIN_URL = `${AUTH_URL}/login-facebook`;
export const LOGOUT_URL = `${AUTH_URL}/logout`;
export const REQUEST_PASSWORD_RESET = `${AUTH_URL}/request-password-reset`;
export const PASSWORD_RESET = `${AUTH_URL}/password-reset`;
export const CHANGE_PASSWORD = `${AUTH_URL}/change-password`;
export const PROFILE = `${AUTH_URL}/profile`;

//user
export const USER_URL = `${BASE_URL}/users`;
export const USER_PROFILE = `${USER_URL}/my-profile`;
export const BUSINESS_DETAILS = `${BASE_URL}/user-business-details`;

//content
export const CONTENT_URL = `${BASE_URL}/cms`;
export const HERO_SLIDERS = `${CONTENT_URL}/hero-sliders`;
export const FRONT_MENUS = `${BASE_URL}/front-menus`;
export const PARENT_CATEGORIES = `${BASE_URL}/categories`;
export const BRAND_URL = `${BASE_URL}/brands`;
export const HIGHLIGHT_URL = `${BASE_URL}/highlights`;
export const MOST_POPULAR_URL = `${BASE_URL}/products/most-popular`;
export const CATEGORY_TREE = `${BASE_URL}/categories/side-menu`;
export const CATEGORY_FILTERS = `${BASE_URL}/products/side-menu-sub-filter`;
export const SEARCH_SUGGESTION = `${BASE_URL}/products/auto-suggest`;
export const DAILY_DEALS_URL = `${BASE_URL}/products/deals-of-the-day`;
export const COUPONS_URL = `${BASE_URL}/coupons`;

//media
export const MEDIA_URL = `${BASE_URL}/media`;

//products
export const PRODUCT_URL = `${BASE_URL}/products`;
export const PRODUCT_REVIEW_URL = `${BASE_URL}/products/slug-review`;
export const RELATED_PRODUCT_URL = `${PRODUCT_URL}/related-product`;
export const RECENT_VIEW_URL = `${BASE_URL}/product-recent-views`;

//cart
export const CART_URL = `${BASE_URL}/carts`;
export const MOVE_TO_WISHLIST_URL = `${CART_URL}/move-wish`;
export const CART_COUNT_URL = `${CART_URL}/total-count`;

//address
export const ADDRESS_URL = `${BASE_URL}/user-addresses`;

//orders
export const ORDER_URL = `${BASE_URL}/orders`;
export const RZ_ORDER_URL = `${ORDER_URL}/rzrpay-order`;

//reviews
export const REVIEW_URL = `${BASE_URL}/product-reviews`;

//wishlist
export const WISHLIST_URL = `${BASE_URL}/wishlists`;

//payment
export const PAYMENT_URL = `${BASE_URL}/payments`;
